import React, { useContext, useState } from 'react'
const SideNavContext = React.createContext()

export const useSideNav = () => useContext(SideNavContext)

export const SideNavProvidor = ({ children }) => {
  const [sideNavOpen, setSideNavOpen] = useState(false)

  return (
    <SideNavContext.Provider value={{ sideNavOpen, setSideNavOpen }}>
      {children}
    </SideNavContext.Provider>
  )
}
